/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { MachineChecklistCategory } from './MachineChecklistCategory';
import {
    MachineChecklistCategoryFromJSON,
    MachineChecklistCategoryFromJSONTyped,
    MachineChecklistCategoryToJSON,
    MachineChecklistCategoryToJSONTyped,
} from './MachineChecklistCategory';

/**
 * 
 * @export
 * @interface TemplateSummaryResponse
 */
export interface TemplateSummaryResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    generalWarningIds?: Array<string>;
    /**
     * 
     */
    category?: MachineChecklistCategory;
    /**
     * 
     */
    activeVersionId?: string;
    /**
     * 
     */
    status?: TemplateSummaryResponseStatusEnum;
    /**
     * 
     */
    latestVersionNumber?: number;
    /**
     * 
     */
    latestVersionStatus?: TemplateSummaryResponseLatestVersionStatusEnum;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const TemplateSummaryResponseStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Disabled: 'DISABLED',
} as const;
export type TemplateSummaryResponseStatusEnum = typeof TemplateSummaryResponseStatusEnum[keyof typeof TemplateSummaryResponseStatusEnum];

/**
 * @export
 */
export const TemplateSummaryResponseLatestVersionStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED',
    Archived: 'ARCHIVED',
} as const;
export type TemplateSummaryResponseLatestVersionStatusEnum = typeof TemplateSummaryResponseLatestVersionStatusEnum[keyof typeof TemplateSummaryResponseLatestVersionStatusEnum];


/**
 * Check if a given object implements the TemplateSummaryResponse interface.
 */
export function instanceOfTemplateSummaryResponse(value: object): value is TemplateSummaryResponse {
    return true;
}

export function TemplateSummaryResponseFromJSON(json: any): TemplateSummaryResponse {
    return TemplateSummaryResponseFromJSONTyped(json, false);
}

export function TemplateSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'generalWarningIds': json['generalWarningIds'] == null ? undefined : json['generalWarningIds'],
        'category': json['category'] == null ? undefined : MachineChecklistCategoryFromJSON(json['category']),
        'activeVersionId': json['activeVersionId'] == null ? undefined : json['activeVersionId'],
        'status': json['status'] == null ? undefined : json['status'],
        'latestVersionNumber': json['latestVersionNumber'] == null ? undefined : json['latestVersionNumber'],
        'latestVersionStatus': json['latestVersionStatus'] == null ? undefined : json['latestVersionStatus'],
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
    };
}

export function TemplateSummaryResponseToJSON(json: any): TemplateSummaryResponse {
    return TemplateSummaryResponseToJSONTyped(json, false);
}

export function TemplateSummaryResponseToJSONTyped(value?: TemplateSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'machineId': value['machineId'],
        'generalWarningIds': value['generalWarningIds'],
        'category': MachineChecklistCategoryToJSON(value['category']),
        'activeVersionId': value['activeVersionId'],
        'status': value['status'],
        'latestVersionNumber': value['latestVersionNumber'],
        'latestVersionStatus': value['latestVersionStatus'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
    };
}

